import playbackSpeedTypes from 'helpers/enums/interactiveVideo/playbackSpeedTypes'
import settingsMenuItemTypes from 'helpers/enums/settings_menu/settingsMenuItemTypes'
import { localize } from 'helpers/translator'

const speedLabels = {
	[playbackSpeedTypes.FASTEST]: localize('interactive_video_settings_playback_speed_fastest'),
	[playbackSpeedTypes.FAST]: localize('interactive_video_settings_playback_speed_fast'),
	[playbackSpeedTypes.NORMAL]: localize('interactive_video_settings_playback_speed_normal'),
	[playbackSpeedTypes.SLOW]: localize('interactive_video_settings_playback_speed_slow'),
	[playbackSpeedTypes.SLOWEST]: localize('interactive_video_settings_playback_speed_slowest'),
}

const playbackSpeedsFormatter = (availableSpeeds, selectedPlaybackSpeed) => {
	const videoPlaybackSpeeds = availableSpeeds.map(speed => (
		{
			type: settingsMenuItemTypes.CHILD,
			payload: {
				id: speed,
				label: speedLabels[speed],
				isSelected: speed === selectedPlaybackSpeed,
			},
		}
	))

	return videoPlaybackSpeeds
}

export default playbackSpeedsFormatter
